import React from "react";

import dayjs from "dayjs";

import {StandardForm} from "./forms/StandardForm";

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_RANGE_EXTENDED = "date_range.extended";

export const getDefaultDateRangeFields = () => ({
	valueFrom: dayjs().subtract(1, "day"),
	valueTo: dayjs(),
});

export const getDefaultExtendedDateFields = (mode = "between") => {
	if (mode === "between") {
		return getDefaultDateRangeFields();
	}
	return {value: dayjs()};
};

const buildDateRangeFields = getFieldValue => [
	{
		label: "From",
		name: "valueFrom",
		_type: "date",
		props: {format: DATE_FORMAT},
		required: true,
		message: "From date is required",
		dependencies: ["valueTo"],
		rules: [
			{
				validator: (_, value) => {
					const to = getFieldValue("valueTo");
					if (value && to && dayjs(value).startOf("day").isAfter(dayjs(to).startOf("day"))) {
						return Promise.reject(new Error("From cannot be later than To"));
					}
					return Promise.resolve();
				},
			},
		],
	},
	{
		label: "To",
		name: "valueTo",
		_type: "date",
		props: {format: DATE_FORMAT},
		required: true,
		message: "To date is required",
		dependencies: ["valueFrom"],
		rules: [
			{
				validator: (_, value) => {
					const from = getFieldValue("valueFrom");
					if (value && from && dayjs(value).startOf("day").isBefore(dayjs(from).startOf("day"))) {
						return Promise.reject(new Error("To cannot be earlier than From"));
					}
					return Promise.resolve();
				},
			},
		],
	},
];

const buildSingleDateFields = () => [
	{
		label: "Date",
		name: "value",
		_type: "date",
		props: {format: DATE_FORMAT},
		required: true,
		message: "Date is required",
	},
];

export function DateRangeFilterForm({form, initialValues, onFinish}) {
	const resolvedInitialValues = initialValues ?? getDefaultDateRangeFields();

	return (
		<StandardForm
			form={form}
			initialValues={resolvedInitialValues}
			fields={buildDateRangeFields(name => form.getFieldValue(name))}
			onFinish={onFinish}
		/>
	);
}

export function ExtendedDateRangeFilterForm({form, mode, initialValues, onFinish}) {
	const resolvedMode = mode || "between";
	const resolvedInitialValues = initialValues ?? getDefaultExtendedDateFields(resolvedMode);

	if (resolvedMode === "between") {
		return <DateRangeFilterForm form={form} initialValues={resolvedInitialValues} onFinish={onFinish} />;
	}

	return (
		<StandardForm
			form={form}
			initialValues={resolvedInitialValues}
			fields={buildSingleDateFields()}
			onFinish={onFinish}
		/>
	);
}

export const validateDateRangeForm = form => form.validateFields(["valueFrom", "valueTo"]);

export const validateExtendedDateRangeForm = (form, mode) =>
	mode === "between" ? validateDateRangeForm(form) : form.validateFields(["value"]);

export const isDateRangeType = type => type === "date_range" || type === DATE_RANGE_EXTENDED;

export const isExtendedDateRangeType = type => type === DATE_RANGE_EXTENDED;
